'use strict';
(function($){
	/*
	 * Vetology.FileManager widget
	 *
	 * @description This ios the main Vetology widget to load the tools needed in the page
	 *				By the time this plugin runs, all othrs should have already been loaded, so this should be the last script to be loaded;
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.FileManager',
		{
			"options": {
				"mimes": {"audio/aac":{"desc":"AAC audio file","ext":[".aac"],"has_icon":true},"application/x-abiword":{"desc":"AbiWord document","ext":[".abw"],"has_icon":false},"application/octet-stream":{"desc":"application/octet-stream","ext":[".exe"],"has_icon":true},"video/x-msvideo":{"desc":"AVI: Audio Video Interleave","ext":[".avi"],"has_icon":true},"application/vnd.amazon.ebook":{"desc":"Amazon Kindle eBook format","ext":[".azw"],"has_icon":false},"application/x-bzip":{"desc":"BZip archive","ext":[".bz"],"has_icon":false},"application/x-bzip2":{"desc":"BZip2 archive","ext":[".bz2"],"has_icon":false},"application/x-csh":{"desc":"C-Shell script","ext":[".csh"],"has_icon":false},"text/css":{"desc":"Cascading Style Sheets (CSS)","ext":[".css"],"has_icon":true},"text/csv":{"desc":"Comma-separated values (CSV)","ext":[".csv"],"has_icon":false},"application/msword":{"desc":"application/msword","ext":[".dot"],"has_icon":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"desc":"Microsoft Word (OpenXML)","ext":[".docx"],"has_icon":true},"application/vnd.ms-fontobject":{"desc":"MS Embedded OpenType fonts","ext":[".eot"],"has_icon":false},"application/epub+zip":{"desc":"Electronic publication (EPUB)","ext":[".epub"],"has_icon":false},"image/gif":{"desc":"Graphics Interchange Format (GIF)","ext":[".gif"],"has_icon":true},"text/html":{"desc":"HyperText Markup Language (HTML)","ext":[".htm,",".html"],"has_icon":true},"image/x-icon":{"desc":"Icon format","ext":[".ico"],"has_icon":false},"text/calendar":{"desc":"iCalendar format","ext":[".ics"],"has_icon":true},"application/java-archive":{"desc":"Java Archive (JAR)","ext":[".jar"],"has_icon":false},"image/jpeg":{"desc":"JPEG images","ext":[".jpeg,",".jpg"],"has_icon":true},"application/javascript":{"desc":"JavaScript (ECMAScript)","ext":[".js"],"has_icon":false},"application/json":{"desc":"JSON format","ext":[".json"],"has_icon":false},"audio/midi":{"desc":"Musical Instrument Digital Interface (MIDI)","ext":[".mid,",".midi"],"has_icon":false},"video/mpeg":{"desc":"MPEG Video","ext":[".mpeg"],"has_icon":false},"application/vnd.apple.installer+xml":{"desc":"Apple Installer Package","ext":[".mpkg"],"has_icon":false},"application/vnd.oasis.opendocument.presentation":{"desc":"OpenDocument presentation document","ext":[".odp"],"has_icon":true},"application/vnd.oasis.opendocument.spreadsheet":{"desc":"OpenDocument spreadsheet document","ext":[".ods"],"has_icon":true},"application/vnd.oasis.opendocument.text":{"desc":"OpenDocument text document","ext":[".odt"],"has_icon":true},"audio/ogg":{"desc":"OGG audio","ext":[".oga"],"has_icon":false},"video/ogg":{"desc":"OGG video","ext":[".ogv"],"has_icon":false},"application/ogg":{"desc":"OGG","ext":[".ogx"],"has_icon":false},"font/otf":{"desc":"OpenType font","ext":[".otf"],"has_icon":false},"image/png":{"desc":"Portable Network Graphics","ext":[".png"],"has_icon":true},"application/pdf":{"desc":"Adobe Portable Document Format (PDF)","ext":[".pdf"],"has_icon":true},"application/vnd.ms-powerpoint":{"desc":"Microsoft PowerPoint","ext":[".ppt"],"has_icon":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"desc":"Microsoft PowerPoint (OpenXML)","ext":[".pptx"],"has_icon":false},"application/x-rar-compressed":{"desc":"RAR archive","ext":[".rar"],"has_icon":true},"application/rtf":{"desc":"Rich Text Format (RTF)","ext":[".rtf"],"has_icon":true},"application/x-sh":{"desc":"Bourne shell script","ext":[".sh"],"has_icon":false},"image/svg+xml":{"desc":"Scalable Vector Graphics (SVG)","ext":[".svg"],"has_icon":false},"application/x-shockwave-flash":{"desc":"Small web format (SWF) or Adobe Flash document","ext":[".swf"],"has_icon":false},"application/x-tar":{"desc":"Tape Archive (TAR)","ext":[".tar"],"has_icon":false},"image/tiff":{"desc":"Tagged Image File Format (TIFF)","ext":[".tif",".tiff"],"has_icon":true},"application/typescript":{"desc":"Typescript file","ext":[".ts"],"has_icon":false},"font/ttf":{"desc":"TrueType Font","ext":[".ttf"],"has_icon":false},"application/vnd.visio":{"desc":"Microsoft Visio","ext":[".vsd"],"has_icon":false},"audio/x-wav":{"desc":"Waveform Audio Format","ext":[".wav"],"has_icon":true},"audio/webm":{"desc":"WEBM audio","ext":[".weba"],"has_icon":false},"video/webm":{"desc":"WEBM video","ext":[".webm"],"has_icon":false},"image/webp":{"desc":"WEBP image","ext":[".webp"],"has_icon":false},"font/woff":{"desc":"Web Open Font Format (WOFF)","ext":[".woff"],"has_icon":false},"font/woff2":{"desc":"Web Open Font Format (WOFF)","ext":[".woff2"],"has_icon":false},"application/xhtml+xml":{"desc":"XHTML","ext":[".xhtml"],"has_icon":false},"application/vnd.ms-excel":{"desc":"Microsoft Excel","ext":[".xls"],"has_icon":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"desc":"Microsoft Excel (OpenXML)","ext":[".xlsx"],"has_icon":true},"application/xml":{"desc":"XML","ext":[".xml"],"has_icon":true},"application/vnd.mozilla.xul+xml":{"desc":"XUL","ext":[".xul"],"has_icon":false},"application/zip":{"desc":"ZIP archive","ext":[".zip"],"has_icon":true},"video/3gpp":{"desc":"3GPP video container","ext":[".3gp"],"has_icon":true},"audio/3gpp":{"desc":"3GPP audio container","ext":[".3gp"],"has_icon":true},"video/3gpp2":{"desc":"3GPP2 video container","ext":[".3g2"],"has_icon":false},"audio/3gpp2":{"desc":"3GPP2 audio container","ext":[".3g2"],"has_icon":false},"application/x-7z-compressed":{"desc":"7-zip archive","ext":[".7z"],"has_icon":false},"application/x-iwork-numbers-sffnumbers":{"desc":"application/x-iwork-numbers-sffnumbers","ext":[".numbers"],"has_icon":true},"application/x-iwork-pages-sffpages":{"desc":"application/x-iwork-pages-sffpages","ext":[".pages"],"has_icon":true},"application/app":{"desc":"application/app","ext":[".app"],"has_icon":true},"audio/mpeg3":{"desc":"audio/mpeg3","ext":[".mp3"],"has_icon":true},"video/mp4v-es":{"desc":"video/mp4v-es","ext":[".mp4"],"has_icon":true},"video/quicktime":{"desc":"video/quicktime","ext":[".qt"],"has_icon":true},"application/pkcs8":{"desc":"application/pkcs8","ext":[".key"],"has_icon":true},"text/x-java-source":{"desc":"text/x-java-source","ext":[".java"],"has_icon":true},"image/photoshop":{"desc":"image/photoshop","ext":[".psd"],"has_icon":true},"application/postscript":{"desc":"application/postscript","ext":[".eps"],"has_icon":true},"image/bmp":{"desc":"image/bmp","ext":[".bmp"],"has_icon":true},"application/acad":{"desc":"application/acad","ext":[".dwg"],"has_icon":true},"application/vnd.oasis.opendocument.spreadsheet-template":{"desc":"application/vnd.oasis.opendocument.spreadsheet-template","ext":[".ots"],"has_icon":true},"application/x-httpd-php":{"desc":"application/x-httpd-php","ext":[".php"],"has_icon":true},"text/x-script.phyton":{"desc":"text/x-script.phyton","ext":[".py"],"has_icon":true},"text/x-c":{"desc":"text/x-c","ext":[".cpp"],"has_icon":true},"application/tga":{"desc":"application/tga","ext":[".tga"],"has_icon":true},"application/dxf":{"desc":"application/dxf","ext":[".dxf"],"has_icon":true},"text/asp":{"desc":"text/asp","ext":[".asp"],"has_icon":true},"application/x-yaml":{"desc":"application/x-yaml","ext":[".yml"],"has_icon":true},"text/x-h":{"desc":"text/x-h","ext":[".h"],"has_icon":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"desc":"application/vnd.openxmlformats-officedocument.wordprocessingml.template","ext":[".dotx"],"has_icon":true},"application/mspowerpoint":{"desc":"application/mspowerpoint","ext":[".pps"],"has_icon":true},"text/plain":{"desc":"text/plain","ext":[".txt"],"has_icon":true},"video/m4v":{"desc":"video/m4v","ext":[".m4v"],"has_icon":true},"video/x-flv":{"desc":"video/x-flv","ext":[".flv"],"has_icon":true},"audio/mpeg":{"desc":"audio/mpeg","ext":[".mpg"],"has_icon":true},"application/midi":{"desc":"application/midi","ext":[".mid"],"has_icon":true},"audio/aiff":{"desc":"audio/aiff","ext":[".aiff"],"has_icon":true},"application/ott":{"desc":"application/ott","ext":[".ott"],"has_icon":true},"application/gnutar":{"desc":"application/gnutar","ext":[".tgz"],"has_icon":true},"application/dmg":{"desc":"application/dmg","ext":[".dmg"],"has_icon":true},"application/iso":{"desc":"application/iso","ext":[".iso"],"has_icon":true}},
				"file_system_map": {
					"current": "",
					"map": {}
				}
			},
			/*
			 * Vetology.FileManager._init
			 *
			 * @description	Initializes the Vetology FormHelper
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o.element.uniqueId();
				o.options.id = o.element.attr("id");
				o._initEvents();
			},
			"_initEvents": function(root, folder){
				var o = this;
				$("body").on("click", "." + o.options.id + ".file_manager .file_select", function(){
					$('.vetologyModal').modal('toggle');
					var el = $(this);
					var html = '<a href="' + el.data("path") + '" target="_blank">';
					if(el.hasClass("has_image")){
						html += '<img src="' + el.data("path") + '" title="' + el.data("name") + '" alt="' + el.data("name") + '"/>';
					} else {
						html += '<span class="' + el.data("class") + '" title="' + el.data("name") + '" alt="' + el.data("name") + '">' + el.data("name") + '</span>';
					}
					html += '</a>';
					o.sendHtml(html);
				});
				$("body").on("click", "." + o.options.id + ".file_manager .folder_select", function(){
					var el = $(this);
					var folder = el.data("folder");
					var root = el.data("root");
					o.showManager(root, folder);
				});
				$("body").on("click", "." + o.options.id + ".file_manager .add_folder", function(){
					var el = $(this);
					var root = el.data("root");
					var folder_name = el.closest(".form-group").find(".folder_name").val().trim();
					if(folder_name == ""){
						$(".add_folder_message").html("Please enter the folder name first");
					} else {
						$("body").Vetology("vetologyLoadStart", "Please wait while I create the folder.", "Please wait while I create the folder.");
						$.ajax(
							{
								type: 'POST', 
								url: '/download/list', 
								data: {
									root: root,
									folder: folder_name
								}, 
								dataType: 'JSON',
								success: function(data){
									el.closest(".form-group").find(".folder_name").val("");
									var new_folder = {
										name: folder_name,
										type: "folder",
										full_path: root + folder_name
									};
									o.options.file_system_map.map[root].folders.push(new_folder);
									o._setMap(data);
									$("body").Vetology("vetologyLoadEnd");
								}
							}
						);
					}
					
				});
			},
			"showManager": function(root, folder){
				var o = this;
				root = typeof root == "undefined" ? "/" : root;
				folder = typeof folder == "undefined" ? "" : folder;
				if(typeof o.options.file_system_map.map[root + folder] == "undefined" && typeof o.options.file_system_map.map[root + "/" + folder] == "undefined"){
					$("body").Vetology("vetologyLoadStart", "Please wait while I load the file system", "Please wait while I load the file system");
					$.ajax(
						{
							type: 'GET', 
							url: '/download/list', 
							data: {
								root: root,
								folder: folder
							}, 
							dataType: 'JSON',
							success: function(data){
								o._setMap(data);
								$("body").Vetology("vetologyLoadEnd");
							}
						}
					);
				} else {
					console.log(root + folder);
					console.log(root + "/" + folder);
					console.log(o.options.file_system_map.map);
					if(typeof o.options.file_system_map.map[root + folder] !== "undefined"){
						o.options.file_system_map.current = o.options.file_system_map.map[root + folder];
					} else {
						o.options.file_system_map.current = o.options.file_system_map.map[root + "/" + folder];
					}
					o._loadFileSelector();
				}
			},
			"_setMap": function(d){
				var o = this;
				$.each(d.files, function(i,f){
					d.files[i] = o._processFile(f);
				});
				o.options.file_system_map.map[d.folder] = d;
				o.options.file_system_map.current = o.options.file_system_map.map[d.folder];
				o._loadFileSelector();
			},
			"_processFile": function(f){
				var o = this;
				f.icon = '';
				if(o.options.mimes[f.mime]){
					$.each(o.options.mimes[f.mime].ext, function(b,e){
						e = e.replace('.', '');
						f.icon += ' vetology-document-file-' + e;
					});
				} else {
					f.icon = 'vetology-file';
				}
				return f;
			},
			"_loadFileSelector": function(){
				var o = this;
				var d = o.options.file_system_map.current;
				var html = '<div class="file_manager ' + o.options.id + '" data-root="' + d.folder + '">';
				var path = d.folder.split('/');
				var is_root = false;
				html += '<div class="path_navigator"><a href="#" class="vetology_pd folder_select" data-root="/" data-folder=""><span class="label label-primary">/</span></a> &nbsp;';
				var last_path = "/";
				var last_folder = "";
				$.each(path, function(i, p){
					if(p != ""){
						var cp = "/";
						$.each(path, function(b, pc){
							if(pc != '' && b < i){
								cp += pc + "/";
							}
						});
						if(path[i+1]){
							last_path = cp;
							last_folder = p;
						}
						html += '<a href="#" class="vetology_pd folder_select" data-root="' + cp + '" data-folder="' + p + '"><span class="label label-primary">' + p + '</span></a> &nbsp;';
					}
				});
				html += '<a href="#" class="vetology_pd folder_select" data-root="' + last_path + '" data-folder="' + last_folder + '"><span class="label label-primary">..</span></a>';
				html += '</div>';
				$.each(d.folders, function(i, f){
					html += '<a href="#" class="folder_select folder_style vetology_pd" data-root="' + d.folder + '" data-folder="' + f.name + '"><span class="vetology-directory f_icon"></span><span class="f_title">' + f.name + '</span></a>';
				});
				$.each(d.files, function(i, f){
					html += '<a href="#" data-title="' + f.mime + '" data-class="' + f.icon + '" class="vetology_pd file_select ' + (f.is_image ? "has_image" : "") + '" data-path="' + f.full_path + '" data-name="' + f.name + '"><span class="f_icon ' + f.icon + '"></span><span class="f_title">' + f.name + '</span>' + (f.is_image ? '<img class="f_image" src="' + f.full_path + '" title="' + f.name + '"/>' : "") + '</a>';
				});
				html += '<div class="file-uploader" data-target="general_upload" data-url="/"></div>';
				html += '<div class="form-inline"><div class="form-group"><label>Add Folder:</label>&nbsp;<input class="form-control folder_name">&nbsp;<a href="#" data-root="' + d.folder + '" class="vetology_pd add_folder"><span class="vetology-add-folder"></span></a> <span class="add_folder_message"></span></div></div>';
				html += '</div>';
				$("body").Vetology("vetologyShowDialog", "File manager:", html, "info");
				setTimeout(
					function(){
						$("." + o.options.id + ".file_manager .file-uploader").FileUpload({
							"extra":{"root":d.folder},
							"uploadCallback": function(loader, data){
								var f = o._processFile(data.f);
								o.options.file_system_map.map[d.folder].files.push(o._processFile(f));
								o.options.file_system_map.current = o.options.file_system_map.map[d.folder];
								o._loadFileSelector();
							}
						});
					}, 15
				);
			},
			"sendHtml": function(html){
				var o = this;
				o.options.onFileSelect(html);
			}
		}
	);
})(jQuery);